import {  useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar'
import axios from 'axios';

function ChavReport() {
  const location = useLocation();
  const { selectedDate } = location.state || {};
  const language = localStorage.getItem("language");
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 
  const [showModal, setShowModal] = useState(true);
  const [countTotal1to5, setCountTotal1to5] = useState('');
  const [countTotal6to8, setCountTotal6to8] = useState('');

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() +1 ); 
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); 
  const [countCookedDays1to5, setCountCookedDays1to5] = useState(0);
  const [countCookedDays6to8, setCountCookedDays6to8] = useState(0);
  const [countlabharthi1to5, setCountlabharthi1to5] = useState(0);
  const [countlabharthi6to8, setCountlabharthi6to8] = useState(0);
  const [madatnissankya, setmadatnissankya] = useState(0); 
  const [rate1to5kendra, setRate1to5kendra] = useState(0); 
  const [rate1to5rajya, setRate1to5rajya] = useState(0); 
  const [rate6to8kendra, setRate6to8kendra] = useState(0);
  const [rate6to8rajya, setRate6to8rajya] = useState(0);
  const [mandhankendra, setmandhankendra] = useState(0);
  const [mandhanrajya, setmandhanrajya] = useState(0);
  const [textareavalue, settextareavalue] = useState('');

  const fetchSchoolData = () => {
    const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;

    fetch(firebaseDatabaseUrl)
      .then(response => response.json())
      .then(data => {
        setSchoolData(data); 
      })
      .catch(error => {
        console.error('Error fetching school data from Firebase:', error);
      });
  };

  useEffect(() => {
    fetchSchoolData(); 
  }, [selectedDate]); 

  const months = [
    { value: 1, label: language === "English" ? "Jan" : "जानेवारी" },
    { value: 2, label: language === "English" ? "Feb" : "फेब्रुवारी" },
    { value: 3, label: language === "English" ? "Mar" : "मार्च" },
    { value: 4, label: language === "English" ? "Apr" : "एप्रिल" },
    { value: 5, label: language === "English" ? "May" : "मे" },
    { value: 6, label: language === "English" ? "June" : "जून" },
    { value: 7, label: language === "English" ? "July" : "जुलै" },
    { value: 8, label: language === "English" ? "Aug" : "ऑगस्ट" },
    { value: 9, label: language === "English" ? "Sept" : "सप्टेंबर" },
    { value: 10, label: language === "English" ? "Oct" : "ऑक्टोबर" },
    { value: 11, label: language === "English" ? "Nov" : "नोव्हेंबर" },
    { value: 12, label: language === "English" ? "Dec" : "डिसेंबर" },
  ];

  const handleFetchStudentCount = async () => {
    try {
      // Construct the fetch URL
      const fetchUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
  
      // Fetch student data from Firebase
      const response = await axios.get(fetchUrl);
      const studentData = response.data || {};
  
  
      if (!studentData) {
        return; 
      }
  
      // Declare class ranges
      let classRange1 = [];
      let classRange2 = [];
  
     
      if (language === 'English') {
        classRange1 = ['Class I', 'Class II', 'Class III', 'Class IV', 'Class V'];
        classRange2 = ['Class VI', 'Class VII', 'Class VIII'];
      } else {
        classRange1 = ['इयत्ता पहिली', 'इयत्ता दुसरी', 'इयत्ता तिसरी', 'इयत्ता चौथी', 'इयत्ता पाचवी'];
        classRange2 = ['इयत्ता सहावी', 'इयत्ता सातवी', 'इयत्ता आठवी'];
      }
  
      let countClass1to5 = 0;
      let countClass6to8 = 0;
  
      // Iterate over student data
      Object.values(studentData).forEach((student) => {
        if (student !== null) { 
  
          const trimmedCurrentClass = student.currentClass.trim(); // Trim extra spaces
  
          if (classRange1.includes(trimmedCurrentClass)) {
            countClass1to5++;
          } else if (classRange2.includes(trimmedCurrentClass)) {
            countClass6to8++;
          }
        }
      });
  
      setCountTotal1to5(countClass1to5);
      setCountTotal6to8(countClass6to8)

     
      return { countClass1to5, countClass6to8 };
    } catch (error) {
      console.error('Failed to fetch student data:', error);
    }
  };
  
  const fetchCookedDays = async () => {
    const fetchUrl1to5 = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/1 To 5/${selectedYear}/${selectedMonth}.json`;
    const fetchUrl6to8 = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/6 To 8/${selectedYear}/${selectedMonth}.json`;

    try {
      
      const response1 = await axios.get(fetchUrl1to5);
      const data1 = response1.data; 
      // Count cooked days and labharthi for 1 To 5
      let count1to5 = 0;
      let labharthiCount1to5 = 0;

      Object.keys(data1).forEach(day => {
        count1to5 += Object.keys(data1[day]).length; // Count entries for each weekday
        Object.values(data1[day]).forEach(entry => {
          if (entry.labharthi) {
            labharthiCount1to5 += parseInt(entry.labharthi, 10); // Sum labharthi values
          }
        });
      });

      setCountCookedDays1to5(count1to5);
      setCountlabharthi1to5(labharthiCount1to5); // Set total labharthi count for 1 To 5

      const response2 = await axios.get(fetchUrl6to8);
      const data2 = response2.data; 

      // Count cooked days and labharthi for 6 To 8
      let count6to8 = 0;
      let labharthiCount6to8 = 0;

      Object.keys(data2).forEach(day => {
        count6to8 += Object.keys(data2[day]).length; // Count entries for each weekday
        Object.values(data2[day]).forEach(entry => {
          if (entry.labharthi) {
            labharthiCount6to8 += parseInt(entry.labharthi, 10); // Sum labharthi values
          }
        });
      });

      setCountCookedDays6to8(count6to8);
      setCountlabharthi6to8(labharthiCount6to8); // Set total labharthi count for 6 To 8

    } catch (error) {
      console.error('Error fetching cooked days:', error);
    }
  };
    useEffect(() => {
      fetchCookedDays()
      handleFetchStudentCount();
    }, [selectedMonth, selectedYear]); 
  
  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p');
      const otherDetails = cloneContent.querySelectorAll('p');
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { // Exclude the school name
          p.style.fontWeight = 'normal'; 
        }
      });
  
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`;
      }
  
      // Add month and year to the print content
      const monthYearSection = cloneContent.querySelector('.Monthname');
      if (monthYearSection) {
        monthYearSection.innerHTML = `
          ${language === "English" ? "Month: " : "महिना: "} 
          ${months[selectedMonth].label} 
          ${selectedYear}
        `;
      }
      const textareaElement = cloneContent.querySelector('textarea');
      if (textareaElement) {
        const valueDiv = document.createElement('div');
        valueDiv.textContent = textareavalue; // Use the state value
        textareaElement.parentNode.replaceChild(valueDiv, textareaElement);
      }
  
      const printWindow = window.open('', '', 'height=600,width=840');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: A4 portrait;
                margin: 3mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
              }
              .modal-content {
                margin: 20px;
              }
              thead {
                background-color: #F0F0F0;
                align-text:center;
              }
                 tbody, textarea {
                align-text:center;
                color:black;
                
              }
              .tip-style {
                text-align: center;
                font-size: 12px;
                margin-top: 20px;
              }
              #month-select {
                margin-right: -30px;
              }
              .Monthname {
                margin-left: 20px;
              }
                td, th, tr{
                border:1px solid black;
              }
               
              .certmaindiv{
                margin-top:80px !important;
              }
                .Dailyrgposhan{
                margin-top:0;
                }
               
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Print content not found');
    }
  };
  

  return (
    <div>
      {/* <Sidebar /> */}
      <div className="main-content-of-page">
        {showModal && (
          <div
            style={{
              position: "fixed",
              top: "0",
              right: "0",
              width: "88%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: "1000",
              marginTop: "25px",
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "30px",
                borderRadius: "10px",
                width: "850px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.9)",
                maxHeight: "90%",
                overflowY: "auto",
                position: "relative",
              }}
            >
              <div className="modal-content">
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "30px",
                    fontFamily: "Arial, sans-serif",
                    border: "1px solid black",
                    borderRadius: "10px",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <thead>
                    {schoolData && (
                      <tr>
                        <th
                          colSpan="10"
                          style={{
                            color: "black",
                            padding: "5px",
                            borderRadius: "10px 10px 0 0",
                            textAlign: "center",
                            lineHeight: "1.8",
                            borderBottom: "1px solid black",
                            borderLeft: "1px solid black",
                            borderRight: "1px solid black",
                            borderTop: "1px solid black",
                            fontSize: "13px",
                            position: "relative",
                          }}
                        >
                          <p>
                            <strong>
                              <h5>
                                {" "}
                                {language === "English"
                                  ? "Certificate"
                                  : "प्रमाणपत्र"}
                              </h5>
                            </strong>
                          </p>

                          <p
                            className="Monthname"
                            style={{
                              position: "absolute",
                              left: "45%",
                              display: "flex",
                              alignItems: "center"
                            }}
                          >
                            {language === "English" ? "Month: " : " माहे: "}
                            
                            <select
    id="month-select"
    value={selectedMonth}
    onChange={(e) => setSelectedMonth(Number(e.target.value))}
    style={{
      marginLeft: "10px",
      paddingTop: "0",
      height: "30px",
      border: "none",
      appearance: "none",
      background: "none",
      padding: "0",
      outline: "none",
      cursor: "pointer",
      fontSize: "13px",
      lineHeight: "normal",
    width: selectedMonth === 4 ? "28px" : (["2", "5", "6"].includes(String(selectedMonth)) ? "30px" : "80px") ,
    width: selectedMonth === 4 && language === "Marathi"? "14px" : "auto"}}
  >
                              {months.map((month) => (
                                <option key={month.value} value={month.value}>
                                  {month.label}
                                </option>
                              ))}
                            </select>

                            <select
                              id="year-select"
                              value={selectedYear}
                              onChange={(e) => setSelectedYear(e.target.value)}
                              style={{
                                paddingTop: "0",
                                height: "30px",
                                border: "none",
                                appearance: "none",
                                background: "none",
                                padding: "0",
                                outline: "none",
                                cursor: "pointer",
                                fontSize: "13px",
                                lineHeight: "normal",
                              }}
                            >
                              <option>2023</option>
                              <option>2024</option>
                              <option>2026</option>
                              <option>2027</option>
                              <option>2028</option>
                              <option>2029</option>
                              <option>2030</option>
                              <option>2031</option>
                              <option>2032</option>
                              <option>2033</option>
                            </select>
                          </p>


                          <p
                            className="Monthname"
                            style={{
                              position: "absolute",
                              right: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {language === "English" ? "Class: 1st To 8 th " : " इ. १ ली ते ८ वी "}
                          

                         
                          </p>

                          <div className='certmaindiv' style={{ marginTop: "60px", fontSize: '14px', textAlign: 'left' }}>
  <p style={{ textIndent: "20px" }}>
    अध्यक्ष/सचिव शाळा व्यवस्थापन समिती _________________, कडून प्रमाणित करण्यात येते की जि.प. शाळा ____________________________________________ या शाळेतील _________________________________ यांना शालेय पोषण आहार अंतर्गत माहे
    <span  style={{ display: "inline-flex" }}>
      <select
        // id="month-select"
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(Number(e.target.value))}
        style={{
          marginLeft: "10px",
          paddingTop: "0",
          height: "30px",
          border: "none",
          appearance: "none",
          background: "none",
          padding: "0",
          outline: "none",
          cursor: "pointer",
          fontSize: "13px",
          lineHeight: "normal",
          width: selectedMonth === 4 ? "28px" : (["2", "5", "6"].includes(String(selectedMonth)) ? "30px" : "80px"),
          width: selectedMonth === 4 && language === "Marathi" ? "14px" : "auto",
          display: "inline-block", // ensures the select is inline
        }}
      >
        {months.map((month) => (
          <option key={month.value} value={month.value}>
            {month.label}
          </option>
        ))}
      </select>

      <select
        id="year-select"
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
        style={{
          paddingTop: "0",
          height: "30px",
          border: "none",
          appearance: "none",
          background: "none",
          padding: "0",
          outline: "none",
          cursor: "pointer",
          fontSize: "13px",
          lineHeight: "normal",
          width: '40px',
          display: "inline-block", // ensures the select is inline
        }}
      >
        <option>2023</option>
        <option>2024</option>
        <option>2026</option>
        <option>2027</option>
        <option>2028</option>
        <option>2029</option>
        <option>2030</option>
        <option>2031</option>
        <option>2032</option>
        <option>2033</option>
      </select>
    </span> मध्ये इ.१ ली ते ५ वी च्या विद्यार्थ्यांसाठी _____ दिवस इ.६ वी ते ८ वी च्या विद्यार्थ्यांसाठी एकूण _____ दिवस अन्न शिजवुन देणेचे काम केले आहे. तसेच योग्य उपक्रमांचा व चविष्ट पोषण आहार होणेसाठी दररोज इ. १ ली ते ५ वी साठी ५० ग्रॅम व इ. ६ वी ते ८ वी साठी ७५ ग्रॅम प्रमाणे विविध भाज्या वापरल्या आहेत आणि खोबरे, कांदा, लसुण इ. मसाल्यांचा योग्य प्रमाणात वापर केला आहे. सदर महिन्यात दर बुधवारी एकूण _____ वेळा ___________________________________________________ असा पूरक आहार दिलेला आहे. अन्न शिजवून देणेचे व महाराष्ट्र शासन, शालेय शिक्षण व क्रीडा विभागातील निर्णय क्र.शापोआ / २०१०/प्र.क्र.१८/ प्राशि ८. दि.२.२. २०११ मधील बाब क्र. ९ नुसार शालेय पोषण आहाराचे सर्व कामकाज पूर्ण केले आहे.
  </p>
  <p>सदर खालीलप्रमाणे पट, लाभार्थी, दिवस यांची माहिती बरोबर असुन त्यानुसार इंधन भाजीपाला तसेच स्वयंपाकी तथा मदतनीस मानधन अदा करणेस हरकत नाही म्हणून दिले असे प्रमाणपत्र.</p>
</div>

                        </th>
                      </tr>
                    )}
                    <tr>
            <th style={{border:'1px solid black', color: 'black'}}> इयत्ता</th>
            <th style={{border:'1px solid black', color: 'black'}}> पट</th>
            <th style={{border:'1px solid black', color: 'black'}}> शिजवलेले दिवस </th>
            <th style={{border:'1px solid black', color: 'black'}}> प्रोग्रेसिव लाभार्थी</th>
            <th style={{border:'1px solid black', color: 'black'}}> हिस्सा</th>
            <th style={{border:'1px solid black', color: 'black'}}> दर </th>
            <th style={{border:'1px solid black', color: 'black'}}> इंधन भाजीपाला देय अनुदान</th>
            <th style={{border:'1px solid black', color: 'black'}}> स्वयंपाकी तथा मदतनीस संख्या</th>
            <th style={{border:'1px solid black', color: 'black'}}> स्वयंपाकी तथा मदतनीस मानधन</th>
            <th style={{border:'1px solid black', color: 'black'}}> शेरा</th>
        </tr>
                  </thead>

                  <tbody style={{textAlign:'center'}}>
        <tr>
            <td style={{border:'1px solid black'}} rowSpan={2}>{language==='English'? "1 To 5": " १ ते ५"}</td>
            <td style={{border:'1px solid black'}} rowSpan={2}>{countTotal1to5}</td>
            <td style={{border:'1px solid black'}} rowSpan={2}>{countCookedDays1to5}</td>
            <td style={{border:'1px solid black'}} rowSpan={2}>{countlabharthi1to5*countCookedDays1to5}</td>
            <td style={{border:'1px solid black'}}>{language==='English'? "Centre": " केंद्र "}</td>
            <td style={{border:'1px solid black'}} className='certborderrate' > <input
        type="number"
        value={rate1to5kendra}
        onChange={(e) => setRate1to5kendra(Number(e.target.value))}
        style={{margin:'0',
          width: "94%",
          height: "46px",
          fontSize: "15px", border:'none'
        }}
      /></td>
            <td style={{border:'1px solid black'}} >{rate1to5kendra * (countlabharthi1to5*countCookedDays1to5)}</td>
            <td className='certborderprint' style={{padding:'0', border:'1px solid black', color: 'black'}} rowSpan={4}><input
        type="number"
        value={madatnissankya}
        onChange={(e) => setmadatnissankya(Number(e.target.value))}
        style={{ margin: '0',
          width: "97%",
          height: "160px",
          padding: "5px",
          fontSize: "16px", border:'none', textAlign:'center'
        }}
      /></td>
            <td className='certborderprint' style={{padding:'0', textAlign:'left' , border:'1px solid black', color: 'black'}} rowSpan={2}> केंद्र - 
           <input
        type="number"
        value={mandhankendra}
        onChange={(e) => setmandhankendra(Number(e.target.value))}
        style={{ margin: '2px',
          width: "94%",
          height: "46px",
          fontSize: "15px", border:'none'
        }}
      />
            </td>
            <td style={{padding:'0', border:'1px solid black', color: 'black'}} rowSpan={4}><textarea value={textareavalue}
                onChange={(e) => settextareavalue(e.target.value)}
                
          rows="4" cols="50"
          style={{ margin: '0',
          width: "60px",
          height: "190px",
          padding: "5px",
          fontSize: "12px", border:'none'
        }}/></td>
        </tr>

        <tr>
          
            <td style={{border:'1px solid black'}}>{language==='English'? "State": " राज्य "}</td>
            <td style={{border:'1px solid black'}} className='certborderrate' > <input
        type="number"
        value={rate1to5rajya}
        onChange={(e) => setRate1to5rajya(Number(e.target.value))}
        style={{ margin: '2px',
          width: "94%",
          height: "46px",
          fontSize: "15px", border:'none'
        }}
      /></td>
            <td style={{border:'1px solid black'}}>{rate1to5rajya * (countlabharthi1to5*countCookedDays1to5)}</td>
            
        </tr>


        
        <tr>
            <td style={{border:'1px solid black'}} rowSpan={2}>{language==='English'?  "6 To 8": " ६ ते ८"}</td>
            <td style={{border:'1px solid black'}} rowSpan={2}>{countTotal6to8}</td>
            <td style={{border:'1px solid black'}} rowSpan={2}>{countCookedDays6to8}</td>
            <td  style={{border:'1px solid black'}} rowSpan={2}>{countlabharthi6to8 * countCookedDays6to8}</td>
            <td style={{border:'1px solid black'}}>{language==='English'? "Centre": " केंद्र "}</td>
            <td style={{border:'1px solid black'}} className='certborderrate'><input
        type="number"
        value={rate6to8kendra}
        onChange={(e) => setRate6to8kendra(Number(e.target.value))}
        style={{ margin: '0',
          width: "94%",
          height: "46px",
          fontSize: "15px", border:'none'
        }}
      /></td>
            <td style={{border:'1px solid black'}}>{rate6to8kendra * (countlabharthi6to8 * countCookedDays6to8)}</td>
            <td className='certborderprint' style={{padding:'0',textAlign:'left',border:'1px solid black'}} rowSpan={2} > राज्य - <input
        type="number"
        value={mandhanrajya}
        onChange={(e) => setmandhanrajya(Number(e.target.value))}
        style={{ margin: '2px',
          width: "94%",
          height: "46px",
          fontSize: "15px", border:'none'
        }}
      /></td>
            
        </tr>


        <tr>
          
            <td style={{border:'1px solid black'}} >{language==='English'? "State": " राज्य "}</td>
            <td  style={{border:'1px solid black'}} className='certborderrate' ><input
        type="number"
        value={rate6to8rajya}
        onChange={(e) => setRate6to8rajya(Number(e.target.value))}
        style={{ margin:'2px',
          width: "94%",
          height: "46px",
          fontSize: "15px", border:'none'
        }}
      />

      </td>
            <td style={{border:'1px solid black'}}>{rate6to8rajya * (countlabharthi6to8 * countCookedDays6to8)  }</td>
        </tr>



        <tr>
            <td style={{border:'1px solid black'}}>{language==="English"? "Total ":"एकूण "}</td>
            <td style={{border:'1px solid black'}}>{countTotal1to5 + countTotal6to8}</td>
            <td style={{border:'1px solid black'}}>{countCookedDays1to5+ countCookedDays6to8}</td>
            <td style={{border:'1px solid black'}}>{(countlabharthi1to5*countCookedDays1to5) + (countlabharthi6to8* countCookedDays6to8)}</td>
            <td style={{border:'1px solid black'}}>-</td>
          
            <td  style={{border:'1px solid black'}}>{rate1to5kendra +rate1to5rajya + rate6to8kendra + rate6to8rajya}</td>
            <td style={{border:'1px solid black'}}>{(rate1to5rajya * (countlabharthi1to5*countCookedDays1to5))  + (rate6to8rajya * (countlabharthi6to8* countCookedDays6to8)) + (rate1to5kendra * (countlabharthi1to5*countCookedDays1to5)) + (rate6to8kendra  * (countlabharthi6to8* countCookedDays6to8)) }</td>
            <td  style={{border:'1px solid black'}}>{madatnissankya}</td>
            <td style={{border:'1px solid black'}}>{mandhankendra + mandhanrajya}</td>
            <td style={{border:'1px solid black'}}></td>
        </tr> 

        
    </tbody>
                </table>

                <div className="text-center mt-3 Certificate-dailyposhan">
                  <div
                    className="signature-section"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      margin: "0 auto",
                      padding: "0 20px",
                      fontSize: "13px",
                      width: "98%",
                      alignItems: "center",
                      marginTop: "10px",
                    }}>
                    
                    <div className='principal-signature' style={{ textAlign: 'left' }}>
                      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
                        {language === "English" ? "Place" : "स्थळ"} : 
                      </p>
                      <p className='schmgnt'>{language === "English" ? "Date" : "दि."} : </p>
                    </div>

                    <div
                      className="principal-signature"
                      style={{ textAlign: "center" }} >
                      <p className="president-signature"
                        style={{marginBottom: "0" }}>
                        {language === "English" ? "Principal and Secretary" : "मुख्याध्यापक तथा सचिव"}
                      </p>
                    </div>

                    <div
                      className="principal-signature"
                      style={{ textAlign: "right" }}>
                      <p className="president-signature"
                        style={{ marginBottom: "0" }} >
                        {language === "English" ? "President" : "अध्यक्ष"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button
                  onClick={handlePrint}
                  style={{
                    padding: "12px 20px",
                    backgroundColor: "#8A1538",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "16px",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                    transition: "background-color 0.2s ease",
                    marginRight: "10px",
                  }}
                >
                  Print
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChavReport;

const thstyle = {
  fontSize: '14px',
  padding: '0px',
  fontWeight: '600',
  borderBottom: '1px solid black',
  textAlign: 'center',
  borderRight: '1px solid black',
  width: '60px'
}

const thstylebody = {
  fontSize: '12px',
  padding: '7px',
  borderBottom: '1px solid black',
  textAlign: 'center',
  color: 'black',
  borderRight: '1px solid black',
}